import { deleteDB } from "idb";

export default async function (key) {
  await deleteDB(key);
}
